import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

// One people directory (Settings › Users + Settings › Sales colours/initials) behind every AM / Est chip.
let state = { people: [], colors: [], loaded: false };
const subs = new Set();
let inflight = null;
const emit = () => subs.forEach((f) => f());

export const loadPeople = (force = false) => {
  if (inflight && !force) return inflight;
  inflight = api.getPeople().then((r) => { state = { people: r.people || [], colors: r.colors || [], loaded: true }; emit(); })
    .catch(() => { state = { ...state, loaded: true }; emit(); });
  return inflight;
};

export function usePeople() {
  const snap = useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
  if (!snap.loaded && !inflight) loadPeople();
  return snap;
}

/** Find a person by email, initials or name (case-insensitive). */
export const findPerson = (people, ref) => {
  const k = String(ref || "").trim().toLowerCase();
  if (!k) return null;
  return people.find((p) => p.email.toLowerCase() === k) || people.find((p) => (p.initials || "").toLowerCase() === k)
    || people.find((p) => (p.name || "").toLowerCase() === k) || null;
};

// Solid fills with white text so chips read in both themes (literal classes for Tailwind JIT).
export const COLOR_CLASS = {
  purple: "bg-purple-600 text-white ring-purple-300/40", teal: "bg-teal-700 text-white ring-teal-300/40",
  green: "bg-green-700 text-white ring-green-300/40", zinc: "bg-zinc-600 text-white ring-zinc-300/40",
  blue: "bg-blue-600 text-white ring-blue-300/40", rose: "bg-rose-600 text-white ring-rose-300/40",
  amber: "bg-amber-700 text-white ring-amber-300/40", cyan: "bg-cyan-700 text-white ring-cyan-300/40",
  indigo: "bg-indigo-600 text-white ring-indigo-300/40", lime: "bg-lime-800 text-white ring-lime-300/40",
  fuchsia: "bg-fuchsia-600 text-white ring-fuchsia-300/40",
};

/** "Jan Van Horn" → "Jan V" (first name + last initial). */
export const shortName = (name) => {
  let n = String(name || "").trim();
  if (n.includes("@")) n = n.split("@")[0].replace(/[._-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());   // email → "First Last"
  const parts = n.split(/\s+/).filter(Boolean);
  return parts.length > 1 ? `${parts[0]} ${parts[1][0].toUpperCase()}` : parts[0] || "";   // surname starts after the first name ("Jan Ver Hoeven" → "Jan V")
};
